// Resolves the `logo` value of a support-company card (PB-347).
// Two forms work, so a logo can be added from card config like any other text:
//   1. A link  – "https://…", "//…", "data:…" or a public path such as "/assets/x.png"
//   2. A file in the repo – the file name (or path) of an image in src/assets/logos,
//      e.g. "Hope4U.svg" or "src/assets/logos/Hope4U.svg"

const repoLogos = import.meta.glob('/src/assets/logos/*.{png,jpg,jpeg,svg,webp}', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

const repoLogosByFileName: Record<string, string> = Object.fromEntries(
  Object.entries(repoLogos).map(([path, url]) => [
    (path.split('/').pop() ?? path).toLowerCase(),
    url,
  ]),
);

const LINK_PATTERN = /^(https?:)?\/\/|^data:|^\//i;

export function resolveSupportCompanyLogo(logo?: string): string | undefined {
  const value = logo?.trim();
  if (!value) return undefined;
  if (LINK_PATTERN.test(value) && !value.startsWith('/src/')) return value;

  const fileName = (value.split(/[\\/]/).pop() ?? value).toLowerCase();
  return repoLogosByFileName[fileName];
}
